function adjustFixedHeader(params) {
	const $promptMessageSelector = $(".prompt-message");
	if ($($promptMessageSelector).hasClass("js-message-opened")) {
		$(`.${params.adjustSelector}`).removeClass(params.adjustSelector + "--adjust-top");
	}
	$(window).on("scroll", function () {
		var selector;
		var scrollTop;
		if (!$(this.$promptMessageSelector).hasClass("js-message-closed")) {
			selector = $(`.${params.adjustSelector}`);
			scrollTop = $(window).scrollTop();
			if (scrollTop > params.scrollValue) {
				$(selector).addClass(params.adjustSelector + "--adjust-top");
			} else {
				$(selector).removeClass(params.adjustSelector + "--adjust-top");
			}
		}
	});
}

export { adjustFixedHeader };
